import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

export default function useProposalData(dealId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!dealId) {
      setError('No deal ID provided');
      setLoading(false);
      return;
    }

    let cancelled = false;

    async function fetchData() {
      try {
        const res = await fetch(`${API_URL}/api/proposal/${dealId}`);
        if (!res.ok) {
          if (res.status === 404) throw new Error('Proposal not found');
          throw new Error(`Failed to load proposal (${res.status})`);
        }
        const json = await res.json();
        if (!cancelled) {
          setData(json);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, [dealId]);

  return { data, loading, error };
}
